document.documentElement.classList.replace('no-js','js');
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      const select = section.querySelector('[data-variant-select]');
      if (!select || select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = section.querySelector('[data-product-price]');
        const button = section.querySelector('[data-add-button]');
        const available = option.dataset.available === 'true';
        price.textContent = option.dataset.price;
        price.setAttribute('aria-live','polite');
        button.disabled = !available;
        const icon = button.querySelector('svg');
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        if (icon) button.append(icon);
        const url = new URL(location.href);
        url.searchParams.set('variant',option.value);
        history.replaceState({},'',url);
      });
    });
    root.querySelectorAll('.motion-toggle').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const paused = document.body.dataset.motionPaused !== 'true';
        document.body.dataset.motionPaused = String(paused);
        document.querySelectorAll('.motion-toggle').forEach(control => {
          control.setAttribute('aria-pressed',String(paused));
          control.textContent = paused ? control.dataset.playLabel : control.dataset.pauseLabel;
        });
      });
    });
    root.querySelectorAll('.mobile-menu').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('click',event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown',event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-visible',entry.isIntersecting)),{rootMargin:'60px'});
      root.querySelectorAll('.hero-landscape,.footer-landscape').forEach(element => observer.observe(element));
    } else root.querySelectorAll('.hero-landscape,.footer-landscape').forEach(element => element.classList.add('is-visible'));
  };
  initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
